import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';
import { eventBus } from '../common/services/eventBus';
import { showToast } from '../common/UI/ToastNotification';
import AppGetIcon from '../common/UI/AppGetIcon';
import { toast } from 'react-toastify';

interface ProtectedRouteProps {
  redirectTo?: string;
}

const ProtectedRoute: React.FC<React.PropsWithChildren<ProtectedRouteProps>> = ({
  children,
  redirectTo = "/login",
}) => {
  const { loading, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const toastShown = useRef(false);

  useEffect(() => {
    if (loading) return;

    if (!isAuthenticated) {
      if (!toastShown.current) {
        toast.warning(
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <AppGetIcon name="iconAlert" />
            No Autorizado
          </div>,
          { icon: false }
        );
        toastShown.current = true;
      }
      navigate(redirectTo, { replace: true });
    }

    const handleNetworkError = (message: any) => {
      showToast(message, 'error');
    };

    eventBus.on('networkError', handleNetworkError);

    return () => {
      eventBus.off('networkError', handleNetworkError);
    };
  }, [loading, isAuthenticated, navigate, redirectTo]);

  if (loading || !isAuthenticated) {
    return null;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
